import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	openPreview: {
		id: 'version-issue-associated-designs.design-carousel.design-card.open-preview',
		defaultMessage: 'Open preview',
		description: 'Button label to open the design preview',
	},
	seeAll: {
		id: 'version-issue-associated-designs.design-carousel.design-card.see-all',
		defaultMessage: 'See all',
		description: 'The button label to see all the issues linked to this design',
	},
	linkedTo: {
		id: 'version-issue-associated-designs.design-carousel.design-card.linked-to',
		defaultMessage: 'Linked to',
		description: 'The title of the section that shows issues that are linked to the current design',
	},
	issueIconLabel: {
		id: 'version-issue-associated-designs.design-carousel.design-card.issue-icon-label',
		defaultMessage: 'Issue icon',
		description: 'The label of the issue icon',
	},
	manyIssues: {
		id: 'version-issue-associated-designs.design-carousel.design-card.many-issues',
		defaultMessage: 'Multiple issues',
		description: 'Indicating multiple issues are associated with the design',
	},
});
